export interface ComicAuthor {
  name: string;
  avatar: string;
}

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
  viewCount: number;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  subtitle: string;
  cover: string;
  banner: string;
  category: string;
  categorySlug: string;
  tags: string[];
  author: ComicAuthor;
  description: string;
  longDescription: string;
  status: '连载中' | '已完结';
  rating: number;
  ratingCount: number;
  totalViews: number;
  totalFavorites: number;
  totalChapters: number;
  chapters: ComicChapter[];
  updatedAt: string;
  createdAt: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const categories = [
  { name: '热门推荐', slug: 'recommended', icon: 'ri-fire-line', color: 'primary' },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', color: 'accent' },
  { name: '玄幻', slug: 'fantasy', icon: 'ri-magic-line', color: 'secondary' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line', color: 'primary' },
  { name: '校园', slug: 'school', icon: 'ri-book-open-line', color: 'accent' },
  { name: '科幻', slug: 'scifi', icon: 'ri-rocket-line', color: 'secondary' },
  { name: '武侠', slug: 'martial', icon: 'ri-sword-line', color: 'primary' },
  { name: '宫廷', slug: 'palace', icon: 'ri-vip-crown-line', color: 'accent' },
  { name: '恐怖', slug: 'horror', icon: 'ri-ghost-line', color: 'secondary' },
  { name: '竞技', slug: 'sports', icon: 'ri-boxing-line', color: 'primary' },
  { name: '美食', slug: 'food', icon: 'ri-restaurant-line', color: 'accent' },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'sword-and-magic',
    title: '剑与魔法',
    subtitle: '異世界冒險譚',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%2C%20sword%20and%20magic%20theme%2C%20epic%20adventure%20with%20a%20warrior%20holding%20a%20glowing%20sword%20against%20a%20dark%20castle%20background%2C%20dramatic%20lighting%2C%20vibrant%20colors%2C%20webtoon%20style%20illustration%2C%20clean%20composition%2C%20manga%20cover%20design&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20battle%20scene%20in%20Korean%20manhwa%20style%2C%20warrior%20with%20sword%20and%20magic%20effects%2C%20dramatic%20lighting%20with%20warm%20golden%20and%20red%20tones%2C%20cinematic%20composition%2C%20anime%20style%20background%2C%20detailed%20illustration&width=1200&height=500&seq=comic-banner-01&orientation=landscape',
    category: '玄幻',
    categorySlug: 'fantasy',
    tags: ['冒险', '战斗', '魔法', '異世界'],
    author: { name: '金泰亨', avatar: '' },
    description: '平凡少年意外穿越到魔法世界，手持传说中的圣剑，踏上拯救王国的冒险之旅。在这个充满魔法与怪物的世界中，他将如何书写属于自己的传奇？',
    longDescription: '李明是一个普通的大学生，因一次意外穿越到了神秘的魔法世界——艾泽拉斯大陆。在这里，他发现自己拥有驾驭传说圣剑的能力。为了寻找回家的路，他必须联合精灵、矮人和龙族的力量，对抗黑暗魔王。每一场战斗都是生死的考验，每一个伙伴都承载着希望。这部漫画以精美的画风和紧张刺激的剧情，带你进入一个全新的奇幻世界。',
    status: '连载中',
    rating: 4.8,
    ratingCount: 12580,
    totalViews: 3580000,
    totalFavorites: 286000,
    totalChapters: 186,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch1-${i + 1}`,
      title: `第${186 - i}话 ${['命运的相遇', '觉醒之力', '黑暗来袭', '希望之光', '决战前夕'][i % 5]}`,
      number: 186 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 4)}-${String(30 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 50000) + 10000,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2024-03-15',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '2',
    slug: 'domineering-ceo',
    title: '霸道总裁爱上我',
    subtitle: '辦公室浪漫喜劇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%2C%20handsome%20CEO%20in%20suit%20and%20beautiful%20woman%20in%20office%20setting%2C%20romantic%20atmosphere%20with%20soft%20pink%20and%20warm%20tones%2C%20webtoon%20style%2C%20elegant%20illustration%2C%20clean%20manhwa%20cover%20design&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Romantic%20office%20scene%20in%20Korean%20manhwa%20style%2C%20couple%20in%20modern%20city%20skyline%20background%2C%20warm%20sunset%20lighting%2C%20soft%20romantic%20mood%2C%20elegant%20webtoon%20illustration%2C%20detailed%20cityscape&width=1200&height=500&seq=comic-banner-02&orientation=landscape',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['恋爱', '职场', '甜宠', '总裁'],
    author: { name: '李智恩', avatar: '' },
    description: '初入职场的菜鸟助理遇上冷面霸道总裁，一场啼笑皆非的办公室恋情即将展开。当冰山遇上阳光，谁能先融化谁的心？',
    longDescription: '刚从大学毕业的林小美进入全国最大的韩氏集团，成为了传说中冷血总裁韩辰逸的私人助理。一个是活泼开朗的职场新人，一个是冷酷无情的商业精英，两人在朝夕相处中擦出了意想不到的火花。从最初的针锋相对到后来的暗生情愫，这场办公室里的浪漫喜剧即将拉开帷幕。画风精致细腻，人物塑造饱满，情节甜中带虐，让人欲罢不能。',
    status: '连载中',
    rating: 4.6,
    ratingCount: 23400,
    totalViews: 8920000,
    totalFavorites: 520000,
    totalChapters: 210,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch2-${i + 1}`,
      title: `第${210 - i}话 ${['初遇总裁', '误会重重', '心动瞬间', '甜蜜告白', '危机来临'][i % 5]}`,
      number: 210 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 4)}-${String(28 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 80000) + 20000,
    })),
    updatedAt: '2026-08-02',
    createdAt: '2024-01-20',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '3',
    slug: 'reborn-urban-cultivator',
    title: '重生之都市修仙',
    subtitle: '都市玄幻鉅作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20fantasy%20comic%20cover%2C%20young%20man%20with%20supernatural%20powers%20in%20modern%20city%2C%20glowing%20energy%20effects%2C%20dramatic%20pose%2C%20dark%20urban%20background%2C%20webtoon%20style%2C%20action%20packed%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Urban%20fantasy%20scene%20Korean%20manhwa%20style%2C%20cultivator%20with%20supernatural%20powers%20in%20modern%20city%20at%20night%2C%20energy%20effects%20and%20neon%20lights%2C%20dramatic%20composition%2C%20action%20webtoon%20illustration&width=1200&height=500&seq=comic-banner-03&orientation=landscape',
    category: '玄幻',
    categorySlug: 'fantasy',
    tags: ['重生', '修仙', '都市', '逆袭'],
    author: { name: '朴志勋', avatar: '' },
    description: '仙帝渡劫失败，重生回到高中时代。这一世，他不再低调，要在这繁华都市中重新踏上修仙之路，改写命运，称霸三界！',
    longDescription: '五百年前，青云仙帝在渡天劫时遭人暗算，含恨陨落。当他再次睁开眼睛，发现自己重生回到了高三那年——一个默默无闻、被同学欺负的普通学生。带着五百年的修仙记忆和无敌功法，他在现代都市中重新修炼，一步步揭开前世陨落的真相。校园、都市、修仙三线交织，节奏明快，爽点密集，是不可错过的都市修仙佳作。',
    status: '连载中',
    rating: 4.9,
    ratingCount: 18900,
    totalViews: 5200000,
    totalFavorites: 410000,
    totalChapters: 245,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch3-${i + 1}`,
      title: `第${245 - i}话 ${['重生归来', '校花同桌', '初显神通', '家族恩怨', '逆天改命'][i % 5]}`,
      number: 245 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 4)}-${String(27 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 60000) + 15000,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2023-11-08',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '4',
    slug: 'night-hunter',
    title: '暗夜猎人',
    subtitle: '懸疑驚悚力作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20comic%20cover%2C%20detective%20in%20trench%20coat%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20moody%20lighting%20with%20shadows%2C%20suspenseful%20webtoon%20style%2C%20dark%20and%20mysterious%20illustration&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Mystery%20noir%20scene%20Korean%20manhwa%20style%2C%20detective%20investigating%20in%20rainy%20city%20at%20night%2C%20dark%20atmosphere%20with%20street%20lamps%2C%20suspenseful%20mood%2C%20detailed%20urban%20webtoon%20background&width=1200&height=500&seq=comic-banner-04&orientation=landscape',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['悬疑', '推理', '犯罪', '暗黑'],
    author: { name: '崔东旭', avatar: '' },
    description: '前刑警韩宇在追踪一起连环失踪案时，逐渐揭开了一个隐藏在都市暗处的骇人真相。每个夜晚，猎人与猎物的身份都在悄然转换。',
    longDescription: '韩宇曾是一名出色的刑警，因为一次行动的失误被迫辞职。如今以私家侦探的身份，他接手了一起看似普通的失踪案。但随着调查深入，他发现案件背后牵扯着庞大的地下组织，而他自己也成了被猎杀的目标。画风冷峻，氛围营造极致，每一个分镜都充满了电影般的质感。喜欢悬疑推理的读者千万不能错过。',
    status: '已完结',
    rating: 4.7,
    ratingCount: 9800,
    totalViews: 2100000,
    totalFavorites: 178000,
    totalChapters: 120,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch4-${i + 1}`,
      title: `第${120 - i}话 ${['失踪案件', '可疑线索', '地下世界', '身份暴露', '最终对决'][i % 5]}`,
      number: 120 - i,
      updatedAt: `2026-0${7 - Math.floor(i / 5)}-${String(20 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 30000) + 8000,
    })),
    updatedAt: '2026-07-15',
    createdAt: '2023-06-01',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '5',
    slug: 'campus-sweetheart',
    title: '校园甜心',
    subtitle: '青春校園物語',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20comic%20cover%2C%20cute%20couple%20in%20school%20uniform%20under%20cherry%20blossoms%2C%20pastel%20pink%20and%20soft%20warm%20tones%2C%20youthful%20webtoon%20style%2C%20sweet%20and%20fresh%20illustration&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=School%20campus%20scene%20Korean%20manhwa%20style%2C%20students%20walking%20under%20cherry%20blossom%20trees%2C%20spring%20sunlight%2C%20youthful%20and%20fresh%20atmosphere%2C%20romantic%20webtoon%20illustration%2C%20soft%20pastel%20colors&width=1200&height=500&seq=comic-banner-05&orientation=landscape',
    category: '校园',
    categorySlug: 'school',
    tags: ['校园', '恋爱', '青春', '甜蜜'],
    author: { name: '尹秀雅', avatar: '' },
    description: '转学第一天就遇到了全校最受欢迎的校草，原本平静的校园生活就此天翻地覆。甜到发齁的校园恋爱故事，准备好你的少女心了吗？',
    longDescription: '苏小糖因为父母工作的关系转学到了首尔的一所高中。开学第一天，她就不小心撞到了全校公认的校草——姜宇彬。更巧的是，他们居然成了同桌。一个是开朗可爱的甜心女孩，一个是外表冷酷内心温柔的学霸男神。在日常的相处中，两人之间慢慢萌生了青涩的感情。这部漫画以清新甜美的画风和细腻的情感描写，完美还原了青春时期最美好的心动瞬间。',
    status: '连载中',
    rating: 4.5,
    ratingCount: 15600,
    totalViews: 4450000,
    totalFavorites: 330000,
    totalChapters: 98,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch5-${i + 1}`,
      title: `第${98 - i}话 ${['转学第一天', '同桌的你', '心动信号', '误会与和解', '甜蜜告白'][i % 5]}`,
      number: 98 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 4)}-${String(26 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 45000) + 12000,
    })),
    updatedAt: '2026-08-01',
    createdAt: '2025-02-14',
    isHot: true,
    isNew: true,
    isRecommended: false,
  },
  {
    id: '6',
    slug: 'apocalypse-survival',
    title: '末世生存指南',
    subtitle: '科幻生存大作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20survival%20comic%20cover%2C%20survivors%20in%20post-apocalyptic%20wasteland%2C%20ruined%20city%20background%2C%20survival%20gear%20and%20weapons%2C%20dramatic%20action%20pose%2C%20webtoon%20style%2C%20dark%20and%20gritty%20illustration&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20wasteland%20Korean%20manhwa%20style%2C%20survivors%20battling%20monsters%20in%20ruined%20city%2C%20dramatic%20orange%20sky%2C%20action%20packed%20scene%2C%20sci-fi%20webtoon%20illustration%2C%20cinematic%20composition&width=1200&height=500&seq=comic-banner-06&orientation=landscape',
    category: '科幻',
    categorySlug: 'scifi',
    tags: ['末世', '生存', '科幻', '丧尸'],
    author: { name: '姜民硕', avatar: '' },
    description: '一场突如其来的病毒席卷全球，人类社会瞬间崩塌。在这末日废土之上，一个普通程序员将如何带领幸存者们寻找生的希望？',
    longDescription: '2026年，一种名为"红死病"的超级病毒在全球爆发，感染者在48小时内变异为嗜血怪物。程序员陈凡在灾难发生时被困在公司大楼里，凭借冷静的头脑和平时积累的生存知识，他一边躲避怪物的追杀，一边寻找其他幸存者。在这绝望的世界中，人性的光辉与黑暗同时被放大。这部漫画以硬核的生存设定和紧张的氛围著称，每一页都让人手心冒汗。',
    status: '连载中',
    rating: 4.8,
    ratingCount: 11200,
    totalViews: 3100000,
    totalFavorites: 245000,
    totalChapters: 156,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch6-${i + 1}`,
      title: `第${156 - i}话 ${['病毒爆发', '绝境求生', '幸存者', '基地建立', '反击开始'][i % 5]}`,
      number: 156 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 4)}-${String(25 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 40000) + 10000,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2024-08-10',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: '7',
    slug: 'martial-arts-supreme',
    title: '武林至尊',
    subtitle: '熱血武俠傳奇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20comic%20cover%2C%20warrior%20in%20traditional%20hanbok%20with%20sword%2C%20ancient%20Korean%20palace%20background%2C%20dynamic%20action%20pose%2C%20ink%20wash%20painting%20style%2C%20webtoon%20illustration%2C%20epic%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ancient%20Korean%20martial%20arts%20battle%20scene%2C%20warriors%20fighting%20in%20mountain%20temple%2C%20traditional%20architecture%2C%20dramatic%20composition%2C%20ink%20style%20Korean%20manhwa%2C%20epic%20martial%20arts%20illustration&width=1200&height=500&seq=comic-banner-07&orientation=landscape',
    category: '武侠',
    categorySlug: 'martial',
    tags: ['武侠', '江湖', '复仇', '热血'],
    author: { name: '郑太元', avatar: '' },
    description: '江湖第一高手遭人背叛，跌落山崖后意外获得失传已久的绝世武功秘籍。重出江湖之日，便是清算一切之时！',
    longDescription: '武林盟主独孤一剑在武林大会上遭结拜兄弟暗算，身负重伤跌落万丈深渊。天无绝人之路，他在崖底发现了数百年前一代宗师留下的绝世武功。三年苦修，他不仅伤势痊愈，武功更是精进到出神入化的境界。当他重新踏上江湖路，曾经的朋友已成仇敌，曾经的正义已变腐朽。这一剑，必将斩尽天下不义之人！画风凌厉霸气，战斗场面震撼人心。',
    status: '连载中',
    rating: 4.7,
    ratingCount: 8700,
    totalViews: 1980000,
    totalFavorites: 156000,
    totalChapters: 178,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch7-${i + 1}`,
      title: `第${178 - i}话 ${['武林大会', '跌落悬崖', '绝世秘籍', '重出江湖', '复仇之路'][i % 5]}`,
      number: 178 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 4)}-${String(24 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 35000) + 9000,
    })),
    updatedAt: '2026-08-02',
    createdAt: '2024-05-20',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: '8',
    slug: 'royal-scandal',
    title: '皇室绯闻',
    subtitle: '宮廷浪漫物語',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20romance%20comic%20cover%2C%20princess%20in%20elegant%20hanbok%20dress%2C%20ancient%20palace%20setting%2C%20golden%20and%20warm%20tones%2C%20romantic%20webtoon%20style%2C%20beautiful%20detailed%20royal%20illustration&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ancient%20Korean%20palace%20scene%20manhwa%20style%2C%20royal%20court%20with%20princess%20and%20nobles%2C%20traditional%20architecture%2C%20warm%20lantern%20lighting%2C%20historical%20romance%20webtoon%20illustration%2C%20elegant%20atmosphere&width=1200&height=500&seq=comic-banner-08&orientation=landscape',
    category: '宫廷',
    categorySlug: 'palace',
    tags: ['宫廷', '恋爱', '历史', '权谋'],
    author: { name: '韩素希', avatar: '' },
    description: '不受宠的公主被派往敌国和亲，却在那里遇到了命中注定的王子。宫廷权谋与甜蜜爱情交织，看公主如何在异国宫廷中逆风翻盘。',
    longDescription: '朝鲜王朝末年，小公主李华音因母妃失势，被派往大清和亲。本以为等待她的是悲惨的命运，却不料在清朝宫廷中遇到了温柔而强大的四皇子。两人从互相猜忌到彼此信任，在权谋诡谲的宫廷中携手共进。华丽的宫廷场景、精美的服饰细节、跌宕起伏的剧情，让这部作品成为宫廷恋爱漫画的标杆之作。',
    status: '连载中',
    rating: 4.6,
    ratingCount: 13400,
    totalViews: 3750000,
    totalFavorites: 298000,
    totalChapters: 135,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch8-${i + 1}`,
      title: `第${135 - i}话 ${['和亲之路', '初入宫廷', '暗流涌动', '心意相通', '宫变风云'][i % 5]}`,
      number: 135 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 4)}-${String(23 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 50000) + 15000,
    })),
    updatedAt: '2026-08-01',
    createdAt: '2024-10-05',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: '9',
    slug: 'evil-spirit-retreat',
    title: '恶灵退散',
    subtitle: '靈異恐怖經典',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20comic%20cover%2C%20exorcist%20fighting%20ghost%20in%20haunted%20house%2C%20dark%20and%20eerie%20atmosphere%2C%20supernatural%20elements%2C%20webtoon%20horror%20style%2C%20chilling%20illustration%20with%20cold%20tones&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Haunted%20house%20scene%20Korean%20manhwa%20horror%20style%2C%20abandoned%20building%20with%20supernatural%20phenomena%2C%20dark%20and%20eerie%20atmosphere%2C%20fog%20and%20shadows%2C%20horror%20webtoon%20illustration%2C%20cinematic%20dread&width=1200&height=500&seq=comic-banner-09&orientation=landscape',
    category: '恐怖',
    categorySlug: 'horror',
    tags: ['恐怖', '灵异', '驱魔', '惊悚'],
    author: { name: '安孝燮', avatar: '' },
    description: '拥有阴阳眼的大学生意外卷入一系列灵异事件中，与神秘驱魔师搭档，揭开城市背后不为人知的恐怖真相。胆小慎入！',
    longDescription: '从小就能看到鬼魂的大学生朴志勋，一直努力装作正常人生活。直到某天，他被卷入了一场惊心动魄的灵异事件，遇到了神秘的驱魔师柳真。两人组成搭档，开始调查城市中接连发生的超自然案件。从废弃医院到古老宅邸，每一个案件都隐藏着令人毛骨悚然的真相。画风极具震撼力，恐怖氛围拉满，建议白天阅读。',
    status: '已完结',
    rating: 4.4,
    ratingCount: 7600,
    totalViews: 1650000,
    totalFavorites: 132000,
    totalChapters: 88,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch9-${i + 1}`,
      title: `第${88 - i}话 ${['阴阳眼', '废弃医院', '红衣女鬼', '驱魔仪式', '终极对决'][i % 5]}`,
      number: 88 - i,
      updatedAt: `2026-0${7 - Math.floor(i / 5)}-${String(18 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 25000) + 7000,
    })),
    updatedAt: '2026-07-10',
    createdAt: '2025-01-15',
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: '10',
    slug: 'star-wanderer',
    title: '星际流浪者',
    subtitle: '科幻冒險史詩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20space%20sci-fi%20comic%20cover%2C%20spaceship%20pilot%20in%20futuristic%20armor%2C%20colorful%20nebula%20and%20stars%20background%2C%20action%20pose%2C%20webtoon%20style%2C%20vibrant%20galaxy%20colors%2C%20dynamic%20space%20illustration&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Space%20battle%20scene%20Korean%20manhwa%20style%2C%20futuristic%20spaceships%20fighting%20in%20colorful%20nebula%2C%20laser%20effects%20and%20explosions%2C%20epic%20sci-fi%20webtoon%20illustration%2C%20cinematic%20space%20composition&width=1200&height=500&seq=comic-banner-10&orientation=landscape',
    category: '科幻',
    categorySlug: 'scifi',
    tags: ['星际', '冒险', '机甲', '科幻'],
    author: { name: '宋宇宙', avatar: '' },
    description: '银河系边缘的流浪佣兵偶然发现了一艘远古外星飞船，从而被卷入了一场关乎整个银河命运的巨大阴谋之中。',
    longDescription: '在遥远的未来，人类已经遍布银河系的各个角落。流浪佣兵凯恩在一次任务中偶然发现了一艘沉睡了数百万年的外星飞船。飞船中隐藏着足以改变整个银河格局的秘密。各方势力闻风而动，凯恩不得不在追杀与逃亡中寻找真相。宏大的宇宙观、炫酷的机甲设计、震撼的太空战斗，这部作品将科幻漫画推向了新的高度。',
    status: '连载中',
    rating: 4.9,
    ratingCount: 6500,
    totalViews: 1420000,
    totalFavorites: 118000,
    totalChapters: 67,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch10-${i + 1}`,
      title: `第${67 - i}话 ${['远古飞船', '星际追杀', '神秘信号', '银河议会', '最终真相'][i % 5]}`,
      number: 67 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 4)}-${String(22 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 22000) + 6000,
    })),
    updatedAt: '2026-08-03',
    createdAt: '2025-09-01',
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: '11',
    slug: 'queens-chess-game',
    title: '女王的棋局',
    subtitle: '競技熱血之作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sports%20competition%20comic%20cover%2C%20female%20chess%20player%20in%20intense%20match%2C%20dramatic%20lighting%2C%20competitive%20atmosphere%2C%20webtoon%20style%2C%20elegant%20and%20intense%20illustration&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Chess%20tournament%20scene%20Korean%20manhwa%20style%2C%20intense%20match%20in%20grand%20hall%2C%20dramatic%20spotlight%20lighting%2C%20competitive%20webtoon%20illustration%2C%20psychological%20tension%2C%20elegant%20composition&width=1200&height=500&seq=comic-banner-11&orientation=landscape',
    category: '竞技',
    categorySlug: 'sports',
    tags: ['竞技', '棋类', '热血', '成长'],
    author: { name: '赵贤宇', avatar: '' },
    description: '天才围棋少女在一场意外后失去信心，在神秘教练的引导下重拾棋艺，向着世界冠军的宝座发起冲击。',
    longDescription: '十七岁的林允儿曾是韩国围棋界的明日之星，却在关键的定段赛上遭遇惨败，从此一蹶不振。直到她遇到了一位隐居多年的围棋大师——曾经的世界冠军李沧海。在大师的指导下，她不仅重拾了对围棋的热爱，更领悟了围棋背后的人生哲学。每一场比赛都是对自我极限的挑战，每一步落子都是内心的修行。这部作品以围棋为题材，展现了竞技体育的魅力和少女成长的历程。',
    status: '连载中',
    rating: 4.5,
    ratingCount: 5400,
    totalViews: 980000,
    totalFavorites: 87000,
    totalChapters: 55,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch11-${i + 1}`,
      title: `第${55 - i}话 ${['天才少女', '惨败之后', '神秘教练', '重拾信心', '王者归来'][i % 5]}`,
      number: 55 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 4)}-${String(21 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 18000) + 5000,
    })),
    updatedAt: '2026-08-02',
    createdAt: '2025-11-20',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: '12',
    slug: 'food-hunter',
    title: '美食猎人',
    subtitle: '美食冒險漫畫',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20food%20cooking%20comic%20cover%2C%20chef%20presenting%20delicious%20Korean%20dish%2C%20warm%20kitchen%20atmosphere%2C%20appetizing%20steam%20and%20glowing%20food%2C%20webtoon%20style%2C%20mouthwatering%20illustration&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Korean%20food%20market%20scene%20manhwa%20style%2C%20chef%20cooking%20in%20traditional%20market%2C%20delicious%20Korean%20street%20food%2C%20warm%20evening%20lighting%2C%20appetizing%20webtoon%20illustration%2C%20cozy%20atmosphere&width=1200&height=500&seq=comic-banner-12&orientation=landscape',
    category: '美食',
    categorySlug: 'food',
    tags: ['美食', '料理', '冒险', '治愈'],
    author: { name: '张味觉', avatar: '' },
    description: '味觉超群的料理天才踏上寻找传说中"神之食谱"的旅程，一路品尝各地美食，用料理治愈人心。',
    longDescription: '拥有"神之舌"的少年料理师韩味觉，能够尝出任何料理中的每一种食材和烹饪方法。受到已故祖父的遗愿启发，他踏上了寻找传说中的"神之食谱"的旅程。从首尔的街头小吃到济州岛的海鲜大餐，从传统的韩定食到创新的融合料理，每一道美食背后都藏着动人的故事。画风温馨治愈，美食描绘令人垂涎欲滴，是美食爱好者的必看之作。',
    status: '连载中',
    rating: 4.3,
    ratingCount: 4300,
    totalViews: 780000,
    totalFavorites: 65000,
    totalChapters: 42,
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: `ch12-${i + 1}`,
      title: `第${42 - i}话 ${['神之舌', '街头小吃', '济州海味', '宫廷御膳', '神之食谱'][i % 5]}`,
      number: 42 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 4)}-${String(20 - i).padStart(2, '0')}`,
      viewCount: Math.floor(Math.random() * 15000) + 4000,
    })),
    updatedAt: '2026-08-01',
    createdAt: '2026-03-01',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
];

export const faqData = [
  {
    question: '韩国漫画网上的漫画都是免费的吗？',
    answer: '是的！韩国漫画网上的所有漫画资源均为免费在线阅读，您无需支付任何费用即可畅享精彩韩漫内容。我们致力于为广大漫画爱好者提供优质的免费阅读体验。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们平台上的热门连载漫画通常保持每周更新2-3话的节奏，部分高人气作品甚至能做到日更。您可以在每部漫画的详情页查看具体的更新时间和更新计划。',
  },
  {
    question: '如何在手机上阅读漫画？',
    answer: '韩国漫画网采用响应式设计，完美适配手机、平板和电脑端。您只需在手机浏览器中打开我们的网站，即可享受专门为移动端优化的竖屏阅读模式，获得最佳的阅读体验。',
  },
  {
    question: '支持下载离线阅读吗？',
    answer: '目前我们暂不支持离线下载功能。但您可以通过添加书签的方式收藏喜欢的漫画，方便随时在线阅读。我们正在积极开发更多便捷功能，敬请期待。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过首页顶部的搜索栏输入漫画名称或关键词进行搜索，也可以通过分类页面按照漫画类型（恋爱、玄幻、悬疑等）进行浏览筛选，快速找到感兴趣的漫画作品。',
  },
  {
    question: '遇到页面加载问题怎么办？',
    answer: '如果遇到页面加载缓慢或无法显示的情况，建议您先检查网络连接，尝试刷新页面或清除浏览器缓存。如问题持续存在，欢迎通过"联系我们"页面反馈，我们的技术团队会尽快处理。',
  },
];